import React, {Component} from 'react';
import Modal from 'react-responsive-modal';

const closeSvg = <path
    d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"/>
const ModalChangeToPresential = ({
                                     open = false,
                                     handleClose, title = '',
                                     text = '',
                                     presencial,
                                     handlePresential = () => {
                                     },
                                     handleRemoveInspection = () => {
                                     }
                                 }) => {
    const titleAux = `Inspección ${title}`;

    return (
        <Modal open={open} onClose={handleClose} closeIconSvgPath={closeSvg} center={true} styles={{width: '300px'}}>
            <div className="col-md-12 text-center">
                <span className="h2 m20 ml10 mb10 mt0 block">{titleAux}</span>
                <i className="text-blue icon-circle-warning icon-94"/>
                <div className="mt10">
                    <div className="col-md-9 text-change">
                        <p>{text}</p>
                        <p>Si el cliente solicitó el cambio a presencial, <br/> haz click en el siguiente botón.</p>
                    </div>
                    <button type="button" className="btn btn-outline-secondary w100p"
                            onClick={handlePresential} disabled={presencial === 1}>Enviar a presencial
                    </button>
                    <button type="button" className="btn btn-danger w100p mt10"
                            onClick={handleRemoveInspection} disabled={presencial === 1}>Eliminar inspección
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalChangeToPresential;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/change-to-presential/modal-change-to-presential.js